import React from 'react';

const LocationInMap = ({ data1, data2 }) => {
  return (
    <>
        <div className="st-google-map">
              <iframe title='Google Map' src={data1}></iframe>
        </div>
        <div className="st-google-map">
          <iframe title='Google Map' src={data2}></iframe>
        </div>
    </>
  )
}

export default LocationInMap;
